import { render, staticRenderFns } from "./OfferParamsForm.vue?vue&type=template&id=2c54d637&"
import script from "./OfferParamsForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferParamsForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferParamsForm.vue?vue&type=style&index=0&id=2c54d637&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports